var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tag",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.175,
    height: 34.112,
    viewBox: "0 0 38.175 34.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M29.777,23.224H18.056a2.8,2.8,0,0,0-1.979.82L.82,39.3a2.8,2.8,0,0,0,0,3.96L12.541,54.979a2.8,2.8,0,0,0,3.958,0L31.756,39.725a2.807,2.807,0,0,0,.82-1.982V26.023A2.8,2.8,0,0,0,29.777,23.224Zm-4.9,9.8a2.1,2.1,0,1,1,2.1-2.1A2.1,2.1,0,0,1,24.878,33.022Z",
    transform: "translate(0 -23.224)",
    fill: "#df9426"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(19.157 2.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M235.206,55.224v13.03a2.431,2.431,0,0,1-.714,1.722l-15.5,15.5.238.238a2.8,2.8,0,0,0,3.958,0l14-14a2.8,2.8,0,0,0,.822-1.979V58.023A2.8,2.8,0,0,0,235.206,55.224Z",
    transform: "translate(-218.988 -55.224)",
    fill: "#df9426"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIcon);
export default __webpack_public_path__ + "static/media/pricing_icon.8f58711c8c056c347f5ad0be4fe2279e.svg";
export { ForwardRef as ReactComponent };